import { render, staticRenderFns } from "./BusinessCreateForm.vue?vue&type=template&id=69044df8"
import script from "./BusinessCreateForm.vue?vue&type=script&lang=js"
export * from "./BusinessCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports